import { useCallback, useMemo, useState } from "react";
import { dateTodayMidnight } from "../../../helpers/date";
import { IPersonaProps, MessageBar, MessageBarType } from "@fluentui/react";
import { AcknowledgementsProcess } from "../../../models/AcknowledgementsProcess";
import { DocumentSystem } from "../../../models/DocumentSystem";
import { BatchAcknowledgementSaveDto, GroupDto, UserDto } from "../../../services/generated";
import { useAcknowledgementBatch } from "../../../hooks/services/useAcknowledgementBatch";
import { useProcessList } from "../ProcessList/useProcessList";
import { getColumnsAcknowledgement } from "../../common/ProcessSections/documentAndFileColumns";
import { useNavigate } from "react-router-dom";


export const useAcknowledgementUnit = () => {

    const navigate = useNavigate();
    const {postAcknowledgementForm, getProcessesUsedInUnit, getDocumentsUsedInUnit} =
    useAcknowledgementBatch();
    const {getProcessColumnsAcknowledgement} = useProcessList();

    const today = dateTodayMidnight;
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [commentValue, setCommentValue] = useState<string | undefined>(undefined);
    const [commentError, setCommentError] = useState<boolean>(true);
    const [deadlineError, setDeadlineError] = useState<boolean>(true);
    const [deadlinePastError, setDeadlinePastError] = useState<boolean>(true);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [deadline, setDeadline] = useState<Date | undefined | null>();
    const [documents, setDocuments] = useState<DocumentSystem[] | []>([]);
    const [processes, setProcesses] = useState<AcknowledgementsProcess[] | []>([]);
    const [selectedPersons, setSelectedPersons] = useState<IPersonaProps[] | undefined>([]);
    const [selectedGroups, setSelectedGroups] = useState<IPersonaProps[] | undefined>([]);
    const [peopleError, setPeopleError] = useState<boolean>(true);
    const [isTemplateModalVisible, setIsTemplateModalVisible] = useState<boolean>(false);
    const [changedDocuments, setChangedDocuments] = useState<DocumentSystem[] | []>([]);
    const [selectedKey, setSelectedKey] = useState<number>(-1); 
    const [changedProcesses, setChangedProcesses] = useState<AcknowledgementsProcess[] | []>([]);
    const [processTableTouched, setProcessTableTouched] = useState<boolean>(false);
    const [documentsTableTouched, setDocumentsTableTouched] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<{
    [key: string]: JSX.Element;
  }>({});


      const errorMessageBar = useCallback((message: string) => {
    return <MessageBar messageBarType={MessageBarType.severeWarning}>{message}</MessageBar>;
  }, []);

  const validateParts = (validateElement: boolean, errorMsg: string, errorStr: string) => {
    if (validateElement) {
      const errorText = errorMessageBar(errorStr);
      setErrorMsg(prev => ({
        ...prev,
        [errorMsg]: errorText
      }));
    }
  };

      const onChangeComment = useCallback((newValue?: string) => {
        const div = document.createElement('div');
        div.innerHTML = newValue || '';
        if (!div.innerText && newValue?.indexOf('<img') === -1) {
          setCommentValue('');
          setCommentError(true);
        } else {
          setCommentValue(newValue);
          setCommentError(false);
        }
      }, []);

      const setDeadlineValue = (value: Date | undefined | null) => {
          if (!value) {
            setDeadlineError(true);
          }
          if (value && value.valueOf() < today.valueOf()) {
            setDeadlinePastError(true);
          }
          setDeadlineError(false);
          setDeadlinePastError(false);
          setDeadline(value);
        };


      const openConfirmationModal = () => {
    setErrorMsg({});
    const documentsToSend = documents
      .filter(item => item.checkedAcknowledgementItem === true)
      .map(item => item.id);
    const processesToSend = processes
      .filter(item => item.checkedAcknowledgementItem === true)
      .map(item => item.id);

    const validatePeopleAndGroup = !selectedPersons?.length && !selectedGroups?.length;
    const validateElements = !documentsToSend.length && !processesToSend.length;
    const validateDate = !deadline;
    const deadlineValue = deadline && new Date(deadline).valueOf();
    const isDeadlineThePast = !!(deadlineValue && today.valueOf() > deadlineValue);
    const validateComment = !commentValue || !commentValue.length;

    if(validateComment)
    {
      setCommentError(true);
    }

    const errorElementMsg = 'Neither document nor process selected. Could not send the form';
    validateParts(validateElements, 'errorElementMsg', errorElementMsg);
    const errorPeopleMsg = 'Neither people nor group selected. Could not send the form';
    validateParts(validatePeopleAndGroup, 'errorPeopleMsg', errorPeopleMsg);
    const errorDateMsg = 'Deadline is required. Could not send the form';
    validateParts(validateDate, 'errorDateMsg', errorDateMsg);
    const errorDatePastMsg = 'Deadline is in the past. Could not send the form';
    validateParts(isDeadlineThePast, 'errorDatePastMsg', errorDatePastMsg);
    const errorCommentMsg = 'Comment is required. Could not send the form';
    validateParts(validateComment, 'errorCommentMsg', errorCommentMsg);

    if (
      validateElements ||
      validatePeopleAndGroup ||
      validateDate ||
      isDeadlineThePast ||
      validateComment
    ) {
      return;
    }
    console.log("openConfirmationModal")
    setIsModalVisible(true);
    console.log(isModalVisible)
  };


   const collectPersons = (value: IPersonaProps[] | undefined) => {
      setSelectedPersons(value);
      setPeopleError((!value || !value.length) && (!selectedGroups || !selectedGroups.length));
    };

      const collectGroups = (value: IPersonaProps[] | undefined) => {
        setSelectedGroups(value);
        setPeopleError((!value || !value.length) && (!selectedPersons || !selectedPersons.length));
      };

        const openConfirmationTemplateModal = () => {
    setErrorMsg({});
    const documentsToSend = documents
      .filter(item => item.checkedAcknowledgementItem === true)
      .map(item => item.id);
    const processesToSend = processes
      .filter(item => item.checkedAcknowledgementItem === true)
      .map(item => item.id);

    const validateElements = !documentsToSend.length && !processesToSend.length;
    const validateComment = !commentValue || !commentValue.length;

    if(validateComment)
    {
      setCommentError(true);
    }

    const errorElementMsg = 'Neither document nor process selected. Could not send the form';
    validateParts(validateElements, 'errorElementMsg', errorElementMsg);
    const errorCommentMsg = 'Comment is required. Could not send the form';
    validateParts(validateComment, 'errorCommentMsg', errorCommentMsg);

    if (
      validateElements ||
      validateComment
    ) {
      return;
    }
    setIsTemplateModalVisible(true);
  };

  const onConfirmForm = (unitId: number) => {
      const documentsToSend = documents
        .filter(item => item.checkedAcknowledgementItem === true)
        .map(item => item.id);
      const processesToSend = processes
        .filter(item => item.checkedAcknowledgementItem === true)
        .map(item => item.id);
      const groups = selectedGroups?.map(item => ({
        azureId: (item.key || undefined) as string,
        userPrincipalName: item.secondaryText || null
      }));
  
      const users = selectedPersons?.map(item => ({
        azureId: (item.key || undefined) as string,
        userPrincipalName: item.secondaryText || null
      }));
  
      if (
        !deadline ||
        !commentValue ||
        (!groups && !users) ||
        (!documentsToSend && !processesToSend)
      ) {
        return;
      }
  
      const formData = {
        documentIds: documentsToSend,
        processIds: processesToSend,
        groups: groups as unknown as GroupDto[],
        users: users as unknown as UserDto[],
        deadline: new Date(deadline.setHours(23, 59, 59, 999)).toISOString(),
        comment: commentValue,
        processId: null,
        unitId: unitId
      };
      onFormSave(formData);
    };
  

  


    const onFormSave = async (formData: BatchAcknowledgementSaveDto) => {
    setIsModalVisible(false);
    setIsLoading(true);
    const result = await postAcknowledgementForm(formData);
    if (!result.apiCode) {
      setChangedDocuments([]);
      setChangedProcesses([]);
      setErrorMsg({});
      setCommentValue(undefined);
      setDeadline(undefined);
      setSelectedPersons([]);
      setSelectedGroups([]);
      setSelectedKey(-1)
      setDocuments(prevDocuments =>
        prevDocuments.map(item => ({...item, checkedAcknowledgementItem: false}))
      );
      setProcesses(prevProcesses =>
        prevProcesses.map(item => ({...item, checkedAcknowledgementItem: false}))
      );
    }
    setIsLoading(false);
  };

    const columsProcessView = useMemo(
      () => getProcessColumnsAcknowledgement(processes, processTableTouched, setProcessTableTouched),
      [processes, processTableTouched, getProcessColumnsAcknowledgement]
    );

      const columnsView = useMemo(
        () =>
          getColumnsAcknowledgement(
            documents,
            undefined,
            documentsTableTouched,
            setDocumentsTableTouched
          ),
        [documents, documentsTableTouched]
      );

        const cancel = (unitId: number) => {
    setChangedDocuments([]);
    setChangedProcesses([]);
    setErrorMsg({});
    navigate(`/unit/${unitId}/manage`);
  };
 

  return {
    onChangeComment,
    setCommentValue,
    commentValue,
    commentError,
    collectPersons,
    collectGroups,
    errorMsg,
    setErrorMsg,
    setDeadlineValue,
    errorMessageBar,
    documents,
    setDocuments,
    deadline,
    isLoading,
    peopleError,
    setIsLoading,
    getProcessesUsedInUnit,
    getDocumentsUsedInUnit,
    today,
    deadlineError,
    deadlinePastError,
    setDeadlinePastError,
    openConfirmationModal,
    openConfirmationTemplateModal,
    processes,
    setProcesses,
    selectedKey,
    cancel,
    changedDocuments,
    changedProcesses,
    columnsView,
    isModalVisible,
    setIsModalVisible,
    columsProcessView,
    onConfirmForm,
    selectedPersons,
    selectedGroups,
    documentsTableTouched,
    processTableTouched,
    setSelectedKey,
    isTemplateModalVisible,
    setIsTemplateModalVisible,
  };
};
